import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Avatar,
  Card,
  Box,
  CardContent,
  Grid,
  Typography,
  makeStyles,
  colors
} from '@material-ui/core';

import ViewedIcon from '@material-ui/icons/NotificationsOff';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';


var numeral = require('numeral');

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%'
  },
  avatar: {
    backgroundColor: colors.green[600],
    height: 56,
    width: 56
  },
    differenceIcon: {
    color: colors.green[900]
  },
  differenceValue: {
    color: colors.green[900],
    marginRight: theme.spacing(1)
  }  
}));

const Resolved = ({ className, ...rest }) => {
  const classes = useStyles();

  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
    >
      <CardContent>
        <Grid
          container
          justify="space-between"
          spacing={3}
        >
          <Grid item>
            <Typography
              color="textSecondary"
              gutterBottom
              variant="h6"
            >
              RESOLVIDOS
            </Typography>
            <Typography
              color="textPrimary"
              variant="h3"
            >
              ({numeral(rest.count).format('0')})
            </Typography>
          </Grid>
          <Grid item>
            <Avatar className={classes.avatar}>
              <ViewedIcon />
            </Avatar>
          </Grid>
        </Grid>
        <Box
          mt={2}
          display="flex"
          alignItems="center"
        >
          <ArrowDownwardIcon className={classes.differenceIcon} />
          <Typography
            className={classes.differenceValue}
            variant="h4"
          >
            {numeral((rest.count / rest.total)).format('0%')}
          </Typography>
          <Typography
            color="textSecondary"
            variant="caption"
          >
            Resolvidos
          </Typography>
        </Box>        
      </CardContent>
    </Card>
  );
};

Resolved.propTypes = {
  className: PropTypes.string
};

export default Resolved;
